import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PhoneRef } from '../../../../shared/models/generated/ziroModels';
import { ZiroIcons } from '../../../../shared/models/ziro-icons.enum';
import { ToastService } from '../../../../shared/services/toast.service';

@Component({
  selector: 'ziro-public-phone-container',
  templateUrl: './public-phone-container.component.html',
  standalone: false,
})
export class PublicPhoneContainerComponent {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private toastService = inject(ToastService);

  onSave(ref: PhoneRef): void {
    this.toastService.pushSaveToast('tkey;shared.model.deskphone.text', ref.name, ZiroIcons.DESKPHONE_SMALL);
    this.router.navigateByUrl(`public-phone/${ref.name}`);
  }

  goHome(): void {
    this.router.navigateByUrl('home');
  }
}
